import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { getShippingMargin } from "@redotech/redo-fulfillment-operations-common/shipping/margin-breakdown";
import { RedoTablePaddedCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { MoneyText } from "@redotech/redo-web/fx/money-text";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { Text } from "@redotech/redo-web/text";

const catalogEntry = fgColumnEntries.shippingMargin;

export const ShippingMarginColumn: Column2<FulfillmentGroupData> = {
  alignment: ColumnAlignment.LEFT,
  key: catalogEntry.key,
  title: catalogEntry.title,
  renderNormalCell: ({ row }: { row: FulfillmentGroupData }) => {
    const margin = getShippingMargin(row);
    return (
      <RedoTablePaddedCell>
        <Text
          as="span"
          fontSize="xs"
          fontWeight="regular"
          textColor="secondary"
        >
          {margin ? <MoneyText signColor struck value={margin} /> : "-"}
        </Text>
      </RedoTablePaddedCell>
    );
  },
  onClick: (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  },
  width: catalogEntry.defaultWidth,
};
